export default "__VITE_ASSET__DEW2P20q__"